export default __webpack_public_path__ + "static/media/svg-akto.bcc8ac74.svg";